













































import Vue from 'vue'
import * as _ from 'lodash'
import ExtranetHeader from './components/ExtranetHeader.vue'
import DeviceList from './components/DeviceList.vue'
import DeviceInfo from './components/DeviceInfo.vue'
import DeviceTab from './components/DeviceTab.vue'


import {
  ExtranetServiceProxy,
  CloseExtranetDTO
} from '@/service-proxies/app-v2/iot-extranet.service-proxies'
import axios from 'axios'

import { ExtranetSocketV2 } from '@/api/ExtranetSocketV2';

import { createExtranetVersionService } from './ExtranetVersionService';

const esp = new ExtranetServiceProxy()

export default Vue.extend({
  name: 'index',
  provide: function(){
    return {
      extranet: this
    }
  },
  components: { ExtranetHeader, DeviceList, DeviceInfo, DeviceTab },
  data() {
    return {
      remoteConnect: undefined,
      connectCode: undefined,
      useDevice: undefined,
      extranetSocketConfig: null, // websocket握手包信息
      extranetLogList: [], // websocket连接日志
      connectTimeout: undefined,
      disconnectTimeout: undefined,
      deviceList: [],
      currentDevice: {},
      deviceTotalCount: 0,
      noMoreData: false,
      loadingTotal: 0,
      departmenTreeNodes: [],
      loadDeviceStatus: false,
      deviceParam: {
        areaNameList: [],
        customerId: '',
        customerName: '',
        extranetState: '',
        current: 1,
        size: 20,
        searchKey: '',
      },
      currentPageSize: undefined,
      selectNode: null,
      treeItems: {},
      isShowDiagnsis: false, // 是否显示诊断信息
      isfoldCode: true, // 是否隐藏诊断码
      newCode: '',
      expiryTimeType: 'A', // 到期类型
      expiryTime: null, // 到期时间
      configList: [], // 配置
      dataList: [], // 记录

      recordParam: {
        pageIndex: 1,
        pageSize: 10
      },
      selectedTab: 1,
      simpleToken: '',
      virtualLinkMsgList: [],
      spinning: false, // 全局加载中
      comPortsList: [],
      extranetGatewayInfo: {},
      versionService: createExtranetVersionService(),
      deviceTabKey:true,
      detailLoading: false
    }
  },
  created() {
    this.remoteConnect = new ExtranetSocketV2();
    this.remoteConnect.connect();
  },
  beforeDestroy() {
    this.remoteConnect.close();
    this.remoteConnect=undefined;
    
  },
  watch:{
    remoteConnect: {
      handler(data:ExtranetSocketV2) {
        this.versionService.currentVersion = data.version;
        this.versionService.checkVersion()
      },
      deep: true,
    },
    currentDevice:{
      handler(newVal,oldVal) {
        if(newVal!==undefined && oldVal===undefined){
          this.deviceTabKey=!this.deviceTabKey;
          return;
        }
        if(newVal.id!==oldVal.id){
          this.deviceTabKey=!this.deviceTabKey;
        }else if(newVal.userVisibleStatus!==oldVal.userVisibleStatus){
          this.deviceTabKey=!this.deviceTabKey;
        }
      },
      deep: true,
      immediate: true,
    }
  },
  mounted(){
    this.initNewVersion();
  },
  methods: {
    async changeTree(value) {
      this.resetListData();
      this.deviceParam.areaNameList = value.isLeaf ? [] : [value.title]
      this.deviceParam.customerId = value.isLeaf ? value.id : ''
      this.deviceParam.customerName =  value.isLeaf ? value.title : ''
      await this.getDeviceList()
     },
    async changeSearch(value) {
      this.resetListData();
      this.deviceParam.searchKey = value ? value : ''
      await this.getDeviceList()
    },
     async changeStatus(value) {
       this.resetListData();
       if (value === '3') {
         this.deviceParam.extranetState = ''
       } else {
         this.deviceParam.extranetState = value
       }
       await this.getDeviceList()
     },
    // 获取设备（工位）列表
    async getDeviceList() {
      if(this.noMoreData){
        console.log('没有更多新数据');
        return;
      }
      let params: any = {
        filter: this.deviceParam.searchKey,
        current: this.deviceParam.current,
        size: this.deviceParam.size,
        extranetState: this.deviceParam.extranetState,
        customerId: this.deviceParam.customerId,
        customerName: this.deviceParam.customerName,
        areaNameList: this.deviceParam.areaNameList
      }
      try {
        this.loadDeviceStatus = true
        const res = await esp.findDeviceList(params)

        if(this.loadingTotal===res.totalCount){
          console.log(`数据已完全加载:${this.loadingTotal}`);
          this.noMoreData=true;
          return;
        }
        this.deviceList = this.deviceList.concat(res.items);
        this.currentPageSize = this.deviceParam.current;
        this.deviceTotalCount = res.totalCount;
        this.loadingTotal+= res.items.length;

        if (this.deviceList.length && !this.useDevice) {
          // 默认选中第一个设备
          this.changeCurrentDevice( this.useDevice || this.deviceList[0])
        }
      } catch (e) {
        this.deviceList = []
      } finally {
        this.loadDeviceStatus = false;
      }


    },
    onDeviceStateChange(device){
      if(this.currentDevice===undefined){
        return;
      }
      if(this.currentDevice.id===device.id){
        this.changeCurrentDevice(device)
      }
      
    },
    resetListData() {
      this.deviceList = []
      this.deviceTotalCount = 0;
      this.loadingTotal= 0;
      this.deviceParam.current = 1
      this.noMoreData = false;
      this.useDevice = undefined;
      this.currentDevice = undefined;

    },
    // 刷新列表
    loadList(data?: any) {
      let { type, searchKey } = data
      // this.deviceParam.searchKey = searchKey ? searchKey : ''
      if (type && type === 'refresh') {
        // 刷新
        this.resetListData();
      } else {
        // 加载更多
        if (this.deviceTotalCount > this.deviceList.length) {
          this.deviceParam.current += 1
        }
      }
      this.getDeviceList()
    },
    // 清空诊断日志
    clearLogs() {
      this.extranetLogList = []
    },
    // 切换选中的设备
    async changeCurrentDevice(data) {
      this.detailLoading=true;
      this.useDevice=data;
      try{
        this.currentDevice = await esp.getDeviceDetails(data.id);
      }finally{
        this.detailLoading=false;
      }
      
    },
    async refreshItem(data){
      const detail =  await esp.getDeviceDetails(data.id);
      if(this.$refs.deviceList){
        this.$refs.deviceList.refreshItem(detail)
      }
    },
    /* 改变连接状态后调用此接口刷新数据 */
    getDeviceInfo(showCode) {
      esp.getDeviceDetails(this.currentDevice.id).then((res) => {
        if (res) {
          this.currentDevice = res
          this.$refs.deviceTab.isfoldCode = !showCode
          this.deviceList.map((item, index) => {
            if (item.id === this.currentDevice.id) {
              this.deviceList[index] = res
            }
          })
          this.deviceList = _.cloneDeep(this.deviceList)
        }
      })
    },
    // 得到生成诊断码接口返回的诊断码和短token，短token用于websocket开启诊断服务
    changeCode(data) {
      const { code, simpleToken } = data
      this.currentDevice.extranetCode = code
      this.simpleToken = simpleToken
    },
    loading(){
      this.spinning = true;
    },
    unloading(){
      this.spinning=false;
    },
    beginConnect(res){
      this.loading();
      this.connectCode = res.extranetCode;

      this.remoteConnect.startRemoteConnection(res.extranetCode)
        .then(res=>{
          this.remoteConnect.refreshServerInfo();
        }).finally(()=>{
          this.unloading();
          this.changeCurrentDevice(this.currentDevice);
          this.$refs.deviceList.refreshListItemState();
          // this.$refs.deviceList.refreshDeviceState(res.gatewayIdList)
        });

    },
    stopConnect(connectCode){
      this.remoteConnect.stopRemoteConnection(connectCode)
        .then(res=>{
          setTimeout(this.remoteConnect.refreshServerInfo,2000)
        });
    },
    refreshDeviceState(){
      this.changeCurrentDevice(this.currentDevice);
      this.refreshItem(this.currentDevice);
      this.unloading();
    },
    async initNewVersion(){

      const versionUrl = (<any>window).masterlink?.extranetVersionUrl+`?t=${new Date().getTime()}`;
      if(!versionUrl){
        console.warn('远程连接版本地址为:', versionUrl,',停止版本判断');
        return;
      }
      const newVersionRequest = await axios.get(`${versionUrl}?v=${new  Date().getTime()}`)
      this.versionService.newVersion = newVersionRequest.data.version
      this.versionService.downloadUrl = newVersionRequest.data.downloadUrl
      this.versionService.checkVersion()
    }
  }
})
